import { ofType } from 'redux-observable';

import { ajax } from 'rxjs/ajax';

import { of } from 'rxjs';

import { map, switchMap, catchError } from 'rxjs/operators';

import {
  boundariesSet,
  concatenateBoundaries,
  concatenateBoundariesByname
} from '../../utilities/helpers';

import saveAs from 'file-saver';
import moment from 'moment';

import {
  DOWNLOAD_AUDIENCE,
  DOWNLOAD_AUDIENCE_SUCCESS,
  DOWNLOAD_AUDIENCE_FAILURE,
} from '../constants';


const downloadAudience = (action$, state$) =>
  action$.pipe(
    ofType(DOWNLOAD_AUDIENCE),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/report/${
          action.csvType
          }?since=${encodeURIComponent(
            state$.value.insightsCriteria.sinceDate
          )}&until=${encodeURIComponent(
            state$.value.insightsCriteria.untilDate
          )}${
          state$.value.insightsCriteria.insightType === 'category' &&
            state$.value.insightsCriteria.subcategory.value
            ? `&customSubcategory=${encodeURIComponent(
            state$.value.insightsCriteria.subcategory.value
            )}`
            : ''
          }${
          state$.value.insightsCriteria.insightType === 'organisation' &&
            state$.value.insightsCriteria.organisation.value
            ? `&organisationId=${
            state$.value.insightsCriteria.organisation.value
            }`
            : ''
          }${
          state$.value.insightsCriteria.regionalArea
            ? `&areas=${encodeURIComponent(
              state$.value.insightsCriteria.regionalArea
            )}`
            : ''
          }${
          boundariesSet(state$.value.insightsCriteria.adm1) === true
            ? `&adm1=${concatenateBoundaries(
              state$.value.insightsCriteria.adm1
            )}`
            : ''
          }${
          boundariesSet(state$.value.insightsCriteria.adm2) === true
            ? `&adm2=${concatenateBoundaries(
              state$.value.insightsCriteria.adm2
            )}`
            : ''
          }${
          boundariesSet(state$.value.insightsCriteria.adm3) === true
            ? `&adm3=${concatenateBoundaries(
              state$.value.insightsCriteria.adm3
            )}`
            : ''
          }${
          boundariesSet(state$.value.insightsCriteria.adm4) === true
            ? `&adm4=${concatenateBoundaries(
              state$.value.insightsCriteria.adm4
            )}`
            : ''
          }&v=${process.env.REACT_APP_VERSION}`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'text',
        crossDomain: true,
      }).pipe(
        map(response => {

          const blob = new Blob(
            [
              `${response.response}`,
            ],
            { type: 'text/csv' }
          );


          const fileName = `LANDMARKSID_${action.reportType}_${action.fileName}_${
            state$.value.insightsCriteria.insightType === 'category' &&
              state$.value.insightsCriteria.subcategory.label
              ? state$.value.insightsCriteria.subcategory.label
              : ''
            }${
            state$.value.insightsCriteria.insightType === 'organisation' &&
              state$.value.insightsCriteria.organisation.label
              ? state$.value.insightsCriteria.organisation.label
              : ''
            }_${
            boundariesSet(state$.value.insightsCriteria.adm0) === true
              ? `${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm0
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm1) === true
              ? `${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm1
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm2) === true
              ? `${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm2
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm3) === true
              ? `${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm3
              )}`
              : ''
            }${
            boundariesSet(state$.value.insightsCriteria.adm4) === true
              ? `${concatenateBoundariesByname(
                state$.value.insightsCriteria.adm4
              )}`
              : ''
            }_${moment(state$.value.insightsCriteria.sinceDate).format(
              'DDMMMYYYY'
            )}_${moment(state$.value.insightsCriteria.untilDate).format(
              'DDMMMYYYY'
            )}.csv`;

          saveAs(blob, fileName);
          return {
            type: DOWNLOAD_AUDIENCE_SUCCESS,
          };
        }),
        catchError(error =>
          of({
            type: DOWNLOAD_AUDIENCE_FAILURE,
            error,
          })
        )
      )
    )
  );

export default downloadAudience;
